import React, { useCallback } from 'react'

import { Box } from '@material-ui/core'
import PropTypes from 'prop-types'

import { getUserType } from 'components/SegmentSelector/UserTypeSelector'
import { DEFAULT_USER_TYPE, USER_TYPE, isParent } from 'components/SegmentSelector/UserTypeSelector'

import getModalConfig from '../get-modal-config'
import AudienceTypeSelector from './AudienceTypeSelector'
import ParentSegmentation from './ParentSegmentation'
import StudentSegmentation from './StudentSegmentation'
import TriggerSelector from './TriggerSelector'

export const Audience = ({ trigger, segment, onError, onUpdate }) => {
  const { enableTriggerSelector } = getModalConfig(trigger)
  const userType = getUserType(segment)
  const updateSegment = useCallback(
    (segment) => {
      onUpdate('Segment', segment)
    },
    [onUpdate],
  )
  return (
    <Box pt={3}>
      {enableTriggerSelector && (
        <TriggerSelector
          isParent={isParent(segment)}
          trigger={trigger}
          onChange={(trigger) => onUpdate('Trigger', trigger)}
        />
      )}
      <AudienceTypeSelector
        trigger={trigger}
        segment={segment}
        onChange={updateSegment}
      >
        {userType === USER_TYPE.parents && (
          <ParentSegmentation
            trigger={trigger}
            segment={segment}
            onChange={updateSegment}
            onError={onError}
          />
        )}
        {userType === USER_TYPE.students && (
          <StudentSegmentation
            trigger={trigger}
            segment={segment}
            onChange={updateSegment}
            onError={onError}
          />
        )}
      </AudienceTypeSelector>
    </Box>
  )
}

Audience.propTypes = {
  trigger: PropTypes.string,
  segment: PropTypes.object,
  isEditing: PropTypes.bool,
  onError: PropTypes.func,
  onUpdate: PropTypes.func.isRequired,
}

Audience.defaultProps = {
  trigger: DEFAULT_USER_TYPE,
}

export default Audience
